import {ChartLegend} from '@refra/modules/common/components'
import type {Shutdown} from '@refra/modules/common/types'
import {DrillingChart} from '@refra/modules/refra-planning/components/KilnShutdownsCard/KilnShutdownsCardBody/KilnShutdownCard/KilnShutdownGanttChart/Drilling'
import {useKilnReplacementQuery} from '@refra/modules/refra-planning/hooks/queries'
import type {KilnShutdown} from '@refra/modules/refra-planning/types'

interface KilnOverviewDrillingsChartProps {
  shutdown: Shutdown
  kilnLength: number
  stepWidth: number
  xAxis: number[]
}

export const KilnOverviewDrillingsChart: React.FC<KilnOverviewDrillingsChartProps> = ({
  shutdown,
  kilnLength,
  stepWidth,
  xAxis
}) => {
  const {data: kilnReplacement} = useKilnReplacementQuery({
    plantUpmId: shutdown.plantUpmId,
    kilnUpmId: shutdown.kilnUpmId,
    shutdownId: shutdown.id
  })

  if (!kilnReplacement) return null

  const kilnShutdown: KilnShutdown = {...shutdown, ...kilnReplacement}

  return (
    <>
      <div className="flex justify-end mb-1" data-cy="kiln_overview_drillings_legend">
        <ChartLegend
          displayItems={['drive', 'tires', 'drillingCritical', 'drillingInfo']}
          translationKey={'refraPlanning.kilnShutdown'}
        />
      </div>
      <div data-cy="kiln_overview_drillings_chart">
        <DrillingChart
          shutdown={kilnShutdown}
          drillings={kilnShutdown.drillings}
          stepWidth={stepWidth}
          kilnLength={kilnLength}
          xAxis={xAxis}
          isReadOnly={true}
        />
      </div>
    </>
  )
}
